export const easterEggAssets = [
	{ 
		url: 'fwxh6s',
	},
];

export const slotMachineIconIds = {
	fireFlower: 'fire-flower',
	coin: 'coin',
	yoshiEgg: 'yoshi-egg',
	powerUpMushroom: 'power-up-mushroom',
	iceFlower: 'ice-flower',
	ninji: 'ninji',
	superBell: 'super-bell'
	// boomerangFlower: 'boomerang-flower',
	// poisonMushroom: 'poison-mushroom',
	// superStar: 'super-star',
	// cherries: 'cherries'
};

const { fireFlower, coin, yoshiEgg, powerUpMushroom, iceFlower, ninji, superBell } = slotMachineIconIds;

export const slotMachineIcons = [
	fireFlower,
	coin,
	yoshiEgg,
	powerUpMushroom,
	iceFlower,
	ninji,
	superBell
	// boomerangFlower,
	// poisonMushroom,
	// superStar,
	// cherries
];

export const ninjiPoses = [
	'ninji-persp',
	'ninji-front',
	'ninji-back',
	'ninji-right'
];